export default __webpack_public_path__ + "static/media/search.bb3abf65.svg";